module.exports = __webpack_public_path__ + "static/media/find_person_wireframe.44cb3c54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/find_person_wireframe.jpg
// module id = 214
// module chunks = 0